module.exports = __webpack_public_path__ + "img/icon8.76c01b0.png";